import React, { useReducer } from "react";
import axios from "axios";
import DashboardContext from "./DashboardContext";
import DashboardReducer from "./DashboardReducer";
import {
  SET_LOADING,
  GET_DASHBOARD_DISPUTES,
  GET_DASHBOARD_PAYMENTS,
  GET_DASHBOARD_TOP_STORES,
  GET_DASHBOARD_TOP_PRODUCTS,
  GET_DASHBOARD_TOP_CAMPAIGNS,
  GET_DASHBOARD_SHOPIFY,
  DASHBOARD_ERROR,
} from "../types";

const DashboardState = (props) => {
  const initialState = {
    loading: false,
    disputes: null,
    payments: null,
    stores: null,
    campaigns: null,
    products: null,
    shopify: null,
    error: null,
  };

  const [state, dispatch] = useReducer(DashboardReducer, initialState);

  // Set Loading
  const setLoading = () =>
    dispatch({
      type: SET_LOADING,
    });

  // Get Paypal Disputes Summary for Dashboard
  const getDashboardDisputes = async (from, to) => {
    setLoading(true);
    if (from && to) {
      try {
        const res = await axios.post("/api/dashboard/get-disputes", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_DASHBOARD_DISPUTES,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: DASHBOARD_ERROR,
          payload: err.response,
        });
      }
    }
  };

  // Get Paypal Payments Summary for Dashboard
  const getDashboardPayments = async (from, to) => {
    setLoading(true);
    if (from && to) {
      try {
        const res = await axios.post("/api/dashboard/get-payments", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_DASHBOARD_PAYMENTS,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: DASHBOARD_ERROR,
          payload: err.response,
        });
      }
    }
  };

  // Get Top Stores Summary for Dashboard
  const getDashboardTopStores = async (from, to) => {
    setLoading(true);
    if (from && to) {
      try {
        const res = await axios.post("/api/dashboard/get-stores", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_DASHBOARD_TOP_STORES,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: DASHBOARD_ERROR,
          payload: err.response,
        });
      }
    }
  };

  // Get Top Campaigns Summary for Dashboard
  const getDashboardTopCampaigns = async (from, to) => {
    setLoading(true);
    if (from && to) {
      try {
        const res = await axios.post("/api/dashboard/get-campaigns", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_DASHBOARD_TOP_CAMPAIGNS,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: DASHBOARD_ERROR,
          payload: err.response,
        });
      }
    }
  };

  // Get Top Products Summary for Dashboard
  const getDashboardTopProducts = async (from, to) => {
    setLoading(true);
    if (from && to) {
      try {
        const res = await axios.post("/api/dashboard/get-products", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_DASHBOARD_TOP_PRODUCTS,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: DASHBOARD_ERROR,
          payload: err.response,
        });
      }
    }
  };

  // Get Shopify Summary for Dashboard
  const getDashboardShopify = async (from, to) => {
    setLoading(true);
    if (from && to) {
      try {
        const res = await axios.post("/api/dashboard/get-shopify", {
          dateFrom: from,
          dateTo: to,
        });
        dispatch({
          type: GET_DASHBOARD_SHOPIFY,
          payload: res.data,
        });
      } catch (err) {
        dispatch({
          type: DASHBOARD_ERROR,
          payload: err.response,
        });
      }
    }
  };

  return (
    <DashboardContext.Provider
      value={{
        loading: state.loading,
        disputes: state.disputes,
        payments: state.payments,
        stores: state.stores,
        campaigns: state.campaigns,
        products: state.products,
        shopify: state.shopify,
        error: state.error,
        getDashboardDisputes,
        getDashboardPayments,
        getDashboardTopStores,
        getDashboardTopCampaigns,
        getDashboardTopProducts,
        getDashboardShopify,
        setLoading,
      }}
    >
      {props.children}{" "}
    </DashboardContext.Provider>
  );
};

export default DashboardState;
